import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDeleteFile = () => {
  const queryClient = useQueryClient();

  const { mutate: deleteFile, isPending } = useAppMutation([QueryKey.DELETE_FILE], {
    mutationFn: ({ companyId, fileId }: { companyId: string; fileId: string }) =>
      ApiService.delete({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'vault', 'files', fileId],
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EVENT] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EVENT_TRANSACTIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.GET_EVENT_TRANSACTIONS_COUNT] });
    },
  });
  return { deleteFile, isPending };
};
